import React, { useCallback } from "react";
import Input, { InputProps } from "@material-ui/core/Input";
import { useDispatch } from "react-redux";

export interface Props extends InputProps {
  onTextChange?: (value: string) => void;
}

const TextInput = (props: Props) => {
  const { onTextChange, ...restProps } = props;
  const { onFocus, onBlur } = props;
  const dispatch = useDispatch();

  const handleFocus = useCallback(
    event => {
      if (onFocus) {
        onFocus(event);
      }
    },
    [dispatch]
  );

  const handleBlur = useCallback(
    event => {
      if (onBlur) {
        onBlur(event);
      }
    },
    [dispatch]
  );

  const handleChange = (event: React.ChangeEvent<{ value: string }>) => {
    const newValue = event.target.value;

    if (onTextChange) {
      onTextChange(newValue);
    }
  };

  return (
    <Input
      {...restProps}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  );
};

export default TextInput;
